(() => {
 const init=()=>document.querySelectorAll('[data-pw-sticky-buy]').forEach(bar=>{
  if(bar.dataset.ready)return;
  const primary=document.getElementById('ProductSubmitButton-'+bar.dataset.section);
  const button=bar.querySelector('[data-pw-sticky-button]');
  const title=document.querySelector('#ProductInfo-'+bar.dataset.section+' h1');
  if(!primary||!button||!title)return;
  bar.dataset.ready='true';
  const sync=()=>{button.disabled=primary.disabled;button.textContent=primary.querySelector('span')?.textContent.trim()||primary.textContent.trim();};
  sync();
  new MutationObserver(sync).observe(primary,{attributes:true,childList:true,subtree:true,characterData:true});
  button.addEventListener('click',()=>{if(!primary.disabled)primary.click();});
  const update=()=>{const r=primary.getBoundingClientRect();bar.hidden=window.innerWidth>=750||title.getBoundingClientRect().top>window.innerHeight||(r.top>=0&&r.bottom<=window.innerHeight);};
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();